import { memo } from "react";
import { Align, Flex } from "./flex";
import { Text } from "./text";
import { SpacingValue } from "./theme/box";
import { TextColorValue, TextSizeValue } from "./theme/typography";

export const TextAndSupportingText = memo(function TextAndSupportingText({
  text,
  supportingText,
  mainTextSize = "lg",
  supportingTextSize = "sm",
  align = "flex-start",
  color,
  gap = "none",
}: {
  text: string;
  supportingText: string;
  mainTextSize?: TextSizeValue;
  supportingTextSize?: TextSizeValue;
  align?: Align;
  color?: TextColorValue;
  gap?: SpacingValue;
}) {
  return (
    <Flex align={align} dir="column" gap={gap}>
      <Text
        fontSize={mainTextSize}
        fontWeight="semibold"
        textColor={color ?? "primary"}
      >
        {text}
      </Text>
      <Text fontSize={supportingTextSize} textColor={color ?? "tertiary"}>
        {supportingText}
      </Text>
    </Flex>
  );
});
